import React, { FC, ReactElement } from 'react';
import { GoBackBtn } from '../../header/GoBackBtn';
import { Title } from '../page-components/Title';
import { Link, useParams } from 'react-router-dom';
import clsx from 'clsx';
import { SITE_ROUTES } from '../../../constants/developer/site-constants/site-constants';

const siteNavigationLinks = [
	{
		path: SITE_ROUTES.SITE_INFO,
		name: 'Site Information',
	},
	{
		path: SITE_ROUTES.SENSE_JS,
		name: 'Sense JS',
	},
	{
		path: SITE_ROUTES.WIDGET,
		name: 'UI Configuration',
	},

];

interface Props {
	siteName: string;
	children: ReactElement;
}

export const SiteDetailsLayout: FC<Props> = (props: Props): React.ReactElement => {
	const { siteName, children } = props;
	const { id } = useParams<{ id: string }>();
	const segments = location.pathname.split('/');
	const activeSection = segments[segments.length - 1];
	return (
		<>
			<div className="mb-5">
				<GoBackBtn path='/developers/sites'/>
			</div>
			<div className="card mb-10">
				<div className="card-header d-flex align-items-center">
					<Title title={siteName} additionalClass="fs-2 fw-bolder"/>
				</div>
				<div className="d-flex align-items-center merchant-navigation px-9">
					{
						siteNavigationLinks.map(({ path, name }) => (
							<Link
								key={path}
								to={`/developers/sites/${id}/${path}`}
								className={clsx(
									'd-flex align-items-center justify-content-center fs-8 fs-sm-7 fw-bolder px-3 h-70px tab-style',
									activeSection === path ? 'text-danger tab-bgc' : 'text-dark'
								)}
							>
								{name}
							</Link>
						))
					}
				</div>
			</div>
			{children}
		</>
	);
};
